import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import dayjs from 'dayjs';
import type { EmberChangeset } from 'ember-changeset';
import { type ValidationMap } from 'ember-changeset-validations';
import { validateDate } from 'ember-changeset-validations/validators';
import Base from 'parog-web/components/forc/provider/base';

import type Owner from '@ember/owner';
import { Changeset } from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
interface Signature {
  Element: HTMLDivElement;
  Args: {
    onDestroy: () => void;
    title: string;
    model: EmberChangeset;
    index: number;
  };
}

export default class CoreAdministrativePatientDescendantComponent extends Component<Signature> {
  changeset: EmberChangeset;

  get rank() {
    const rankNumber = this.args.index + 1;
    return rankNumber + (rankNumber === 1 ? 'er' : 'e');
  }

  #validations = {
    birthyear: [
      validateDate({
        allowBlank: true,
        message:
          'Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date',
        onOrAfter: new Date('01/01/1900')
      }),
      validateDate({
        allowBlank: true,
        message:
          'Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date',
        onOrBefore: dayjs().endOf('day').toDate()
      })
    ]
  } as ValidationMap;

  constructor(owner: Owner, args: Signature['Args']) {
    super(owner, args);
    this.changeset = Changeset(
      this.args.model,
      lookupValidator(this.#validations),
      this.#validations
    );
    this.changeset.on('afterValidation', () => {
      // Save the content of the changeset in the underlying object.
      this.changeset.execute();
    });
  }

  <template>
    <Base @changeset={{this.changeset}} @isReadOnly={{false}} as |Form|>
      <div class='ui segment' ...attributes>
        <h5 class='ui dividing header'>{{this.rank}} {{@title}}</h5>
        <i
          class='trash icon absolute right-0 top-0 m-[0.5em] opacity-[0.5]'
          role='button'
          {{on 'click' @onDestroy}}
        >
        </i>

        <div class='field'>
          <Form.AlignedFieldsRadioGroup
            @title='Sexe'
            @propertyName='gender'
            as |Group|
          >
            <Group.FieldRadio @value='female' @label='Femme' />
            <Group.FieldRadio @value='male' @label='Homme' />
          </Form.AlignedFieldsRadioGroup>
        </div>

        <div class='field'>
          <Form.Date
            @propertyName='birthyear'
            @labelName='Année de naissance'
          />
        </div>

        <div class='field'>
          <Form.Input
            @propertyName='city'
            @labelName='Commune du lieu de vie'
          />
        </div>
      </div>
    </Base>
  </template>
}
